var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SelectContainerInfo"),
        width: "850px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "300px" },
        attrs: {
          "config-module": "130203",
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary", no: "1" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "2" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }